import { Brand } from '@api/catalog';

import { FilterTrigger } from './consts';
import { FilteredBrands } from './types';

const isNumeric = (num: any) => {
    return !isNaN(num);
};

export const isRuLetter = (str: string) => {
    return str.length === 1 && str.match(/^[а-яё]*$/i);
};

export const isEngLetter = (str: string) => {
    return str.length === 1 && str.match(/[a-z]/i);
};

export const filterOfBrands = (brandsArr: Brand[], filterKey = 'Все') => {
    const sortedBrands: FilteredBrands = {};
    switch (filterKey) {
        case FilterTrigger.Default:
            brandsArr.forEach(brand => {
                const isNumber = isNumeric(brand.name[0]) ? FilterTrigger.Numbers : brand.name[0].toLowerCase();

                if (sortedBrands[isNumber]) {
                    sortedBrands[isNumber] = [...sortedBrands[isNumber], brand].sort((a, b) =>
                        a.name.localeCompare(b.name)
                    );
                } else {
                    sortedBrands[isNumber] = [brand];
                }
            });
            break;

        case FilterTrigger.Numbers:
            sortedBrands[FilterTrigger.Numbers] = brandsArr.filter(brand => {
                return isNumeric(brand.name[0]);
            });
            break;

        case FilterTrigger.RuAlphabet:
        case FilterTrigger.EngAlphabet:
            brandsArr.forEach(brand => {
                const letter = brand.name[0].toLowerCase();
                (filterKey === FilterTrigger.EngAlphabet ? isEngLetter(letter) : isRuLetter(letter)) &&
                    (sortedBrands[letter]
                        ? (sortedBrands[letter] = [...sortedBrands[letter], brand].sort((a, b) =>
                              a.name.localeCompare(b.name)
                          ))
                        : (sortedBrands[letter] = [brand]));
            });
            break;

        default:
            sortedBrands[filterKey.toUpperCase()] = brandsArr
                .filter(brand => {
                    return brand.name[0].toUpperCase() === filterKey.toUpperCase();
                })
                .sort((a, b) => a.name.localeCompare(b.name));
            break;
    }

    return sortedBrands;
};
